import React from 'react';
import { shape, bool, instanceOf, func } from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import CATableRow from './CATableRow';

const CATableBody = ({
  definition,
  setSelectedTargets,
  loadMore,
  setView,
  isAllChecked = false,
  selectAllClicked = false,
  onRowChecked,
}) => {
  const renderTableRow = (
    <CATableRow
      data={definition.data}
      loading={definition.loading}
      isAllChecked={isAllChecked}
      selectAllClicked={selectAllClicked}
      onRowChecked={onRowChecked}
    />
  );

  const _renderTbody = () => {
    let renderView = null;
    if (definition.loading && definition.data.length === 0) {
      renderView = (
        <div style={{ padding: '20px', textAlign: 'center' }}>loading...</div>
      );
    } else if (!definition.loading && definition.data.length === 0) {
      if (definition.hasDefinition) {
        renderView = (
          <div
            style={{
              padding: '20px',
              textAlign: 'center',
              marginTop: '10%',
              fontSize: '20px',
            }}
          >
            No matching your search request were found. Please try another
            search.
          </div>
        );
      } else {
        //  renderView = <NoDefinition setView={setView} />;
      }
    }
    return renderView;
  };

  return (
    <div className="ca--table__body ca--flex-col-1">
      {_renderTbody()}
      {definition.data.length > 0 && (
        <InfiniteScroll
          pageStart={definition.response.currentPage}
          loadMore={loadMore}
          hasMore={definition.response.hasMorePages}
          useWindow={false}
          loader={
            <div className="table-loader" key={0}>
              Loading ...
            </div>
          }
        >
          {renderTableRow}
        </InfiniteScroll>
      )}
    </div>
  );
};

CATableBody.propTypes = {
  definition: shape({
    loading: bool,
    error: bool,
    data: instanceOf(Array),
  }),
  setSelectedTargets: func,
  loadMore: func,
  setView: func,
  isAllChecked: bool,
  selectAllClicked: bool,
  onRowChecked: func,
};

CATableBody.defaultProps = {
  definition: {
    loading: true,
    error: false,
    data: [],
  },
};

export default CATableBody;
